module.exports = __webpack_public_path__ + "static/media/emlak.2b9b618b.png";